import { z } from "zod";
import {
  heroSectionContentSchema,
  featuresSectionContentSchema,
  servicesSectionContentSchema,
  aboutSectionContentSchema,
  testimonialsSectionContentSchema,
  reviewsSectionContentSchema,
  newsletterSectionContentSchema,
  pricingSectionContentSchema,
  faqSectionContentSchema,
  contactSectionContentSchema,
  eventsSectionContentSchema,
  ctaBarSectionContentSchema,
  timelineSectionContentSchema,
  blogSectionContentSchema,
  teamSectionContentSchema,
  logoCloudSectionContentSchema,
} from "./sections";
import { eventBookingSectionContentSchema } from "./booking";
import { locationsSectionContentSchema } from "./location";

/**
 * Zod schema for HomePageContent.
 */
export const homePageContentSchema = z.object({
  hero: heroSectionContentSchema,
  features: featuresSectionContentSchema.optional(),
  services: servicesSectionContentSchema.optional(),
  about: aboutSectionContentSchema.optional(),
  testimonials: testimonialsSectionContentSchema.optional(),
  reviews: reviewsSectionContentSchema.optional(),
  newsletter: newsletterSectionContentSchema.optional(),
  pricing: pricingSectionContentSchema.optional(),
  faq: faqSectionContentSchema.optional(),
  contact: contactSectionContentSchema.optional(),
  events: eventsSectionContentSchema.optional(),
  eventBooking: eventBookingSectionContentSchema.optional(),
  ctaBar: ctaBarSectionContentSchema.optional(),
  timeline: timelineSectionContentSchema.optional(),
  blog: blogSectionContentSchema.optional(),
  logoCloud: logoCloudSectionContentSchema.optional(),
  team: teamSectionContentSchema.optional(),
  locations: locationsSectionContentSchema.optional(),
});
